const MDSwitch = {
  root: {
    direction: 'ltr',
  },
};

export default MDSwitch;
